import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllBankDetailByUserId } from '../../../../../../app/store/slices/bank/bank';

export default function useBankDetailsManage() {
    const dispatch = useDispatch();
    const { bankDetails, status } = useSelector((state) => state.bank);
    const { user } = useSelector((state) => state.auth);

    const [isOpenBankModal, setIsOpenBankModal] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        async function fetchBankDetails() {
            if (user?.id && (!bankDetails || bankDetails?.data?.length === 0)) {
                try {
                    setLoading(true);
                    await dispatch(getAllBankDetailByUserId({ user_id: user.id }));
                } catch (error) {
                    console.error('Failed to fetch bank details:', error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchBankDetails();
    }, [user?.id, dispatch, bankDetails]);

    useEffect(() => {
        if (status) {
            setIsOpenBankModal(false);
        }
    }, [status]);

    return {
        isOpenBankModal,
        setIsOpenBankModal,
        bankDetails,
        loading
    };
}
